import { Link } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldEvmVersion from '../fields/ContractVerificationFieldEvmVersion';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';

const MAIN_SOURCES_TYPES = [ '.vy' as const ];
const INTERFACE_TYPES = [ '.vy' as const, '.json' as const ];

const ContractVerificationVyperMultiPartFile = () => {
  const { t } = useTranslation();
  const interfacesHint = (
    <>
      <span>{ t('add_any') } </span>
      <Link href="https://docs.vyperlang.org/en/stable/interfaces.html" target="_blank">{ t('required_interfaces') }</Link>
      <span> { t('main_compiled_contract') }</span>
    </>
  );

  return (
    <ContractVerificationMethod title={ t('Vyper_multi_part_files_title') }>
      <ContractVerificationFieldCompiler isVyper/>
      <ContractVerificationFieldEvmVersion isVyper/>
      <ContractVerificationFieldSources
        name="sources"
        fileTypes={ MAIN_SOURCES_TYPES }
        title={ t('upload_main_source') }
        hint={ t('upload_main_source_tip') }
        required
      />
      <ContractVerificationFieldSources
        name="interfaces"
        fileTypes={ INTERFACE_TYPES }
        multiple
        fullFilePath
        title={ t('interfaces_vy_json') }
        hint={ interfacesHint }
      />
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationVyperMultiPartFile);
